<template>
  <div class="termo">
    <div class="title">Termos de Uso</div>
    <div ref="termoContent" class="content">
      <p>
        Pelos presentes Termos e Condições Gerais, de um lado NETSUPPORT,
        provedor de serviço hospedado sob o domínio
        https://www.netsupport.com.br, de propriedade de NS NET SUPPORT Serviços
        de Tecnologia LTDA, pessoa jurídica de direito privado, inscrita no
        CNPJ/MF nº 20.653.620/0001-37, com sede na Rua Paes Leme 215 –
        Pinheiros, São Paulo – SP, 05424-150, doravante denominada “NETSUPPORT”,
        e, de outro lado, os técnicos que irão aderir à Comunidade de SUPPORTERs
        da NETSUPPORT, doravante denominado apenas “SUPPORTER”, têm entre si,
        certo e ajustado o presente contrato, cujo teor mutuamente aceitam,
        outorgam e, por si, seus herdeiros e seus sucessores, obrigam-se
        fielmente a cumprir, a partir da conclusão do seu cadastro. A aceitação
        expressa destes termos e condições gerais pelo SUPPORTER é absolutamente
        indispensável para sua participação na Comunidade, por meio de cadastro
        na URL https://nssupport.netsupport.com.br. A participação se dará de
        forma não exclusiva, na plataforma de serviços da NETSUPPORT e para a
        prestação de serviços aos usuários CLIENTES que solicitarem reparos
        técnicos através do site https:/www.netsupport.com.br. A não
        concordância dos termos do presente contrato impede o técnico de acessar
        e utilizar os serviços disponibilizados pela NETSUPPORT, bem como de
        prestar serviços aos usuários CLIENTES.
      </p>

      <br />
      <h5 style="font-weight: bold; text-align: left">
        Definições importantes:
      </h5>

      <p>
        <b>SUPPORTERs:</b> é o termo que a NetSupport utiliza para se referir
        aos técnicos de informática cadastrados na plataforma.
      </p>
      <p>
        <b>Comunidade:</b> Conjunto de SUPPORTERs cadastrados na plataforma
        NetSupport com o objetivo comum de ensinar, aprender, relacionar-se e
        ganhar dinheiro.
      </p>
      <p>
        <b>Plataforma:</b> Tecnologia desenvolvida pela NetSupport, onde os
        SUPPORTERs fazem seu cadastro, trocam experiências técnicas e aceitam os
        Jobs técnicos para solução remota ou presencial.
      </p>
      <p>
        <b>Especialidades:</b> Competências técnicas dos SUPPORTERs que são
        informadas na plataforma NetSupport para facilitar a distribuição de
        Jobs.
      </p>
      <p>
        <b>Jobs:</b> Termo utilizado pela NetSupport para se referir aos
        chamados técnicos encaminhados para os SUPPORTERs resolverem.
      </p>
      <p>
        <b>RAT:</b> Relatório de atendimento técnico, documento necessário para
        validação dos atendimentos técnicos presenciais. Ele é assinado pelo
        cliente e pelo SUPPORTER.
      </p>
      <p>
        <b>Atendimento Presencial:</b> Atendimento que requer deslocamento e é
        feito com presença física do técnico dentro do estabelecimento do
        cliente.
      </p>
      <p>
        <b>Atendimento Remoto:</b> Atendimento que não requer deslocamento,
        feito com acesso remoto autorizado pelo cliente através da internet.
      </p>
      <p>
        <b>NS Academy:</b> Tecnologia NetSupport utilizada para formação e
        capacitação dos SUPPORTERs, por meio de treinamentos feitos de forma
        remota, pela internet.
      </p>
      <p>
        <b>NS Community:</b> Tecnologia NetSupport utilizada para comunicação e
        troca de informações entre os SUPPORTERs.
      </p>
      <p>
        <b>Conteúdo:</b> Material de vídeo e/ou áudio, bem como apostilas,
        apresentações e demais ferramentas e instrumentos de suporte e
        treinamento de pessoal, que pode ser utilizado pela NetSupport no NS
        Academy ou por qualquer outro meio que lhe aprouver, no intuito de gerar
        conhecimento à comunidade de técnicos, clientes e parceiros, bem como
        levar informações ao público em geral acerca de assuntos relacionados ao
        seu objeto e área de atuação comercial.
      </p>
      <br />
      <h5 style="font-weight: bold; text-align: left">
        1. OBJETO DO TERMO DE ADESÃO
      </h5>

      <p>
        1.1. O presente instrumento tem por finalidade normatizar e viabilizar o
        acesso e uso pelo SUPPORTER da plataforma NETSUPPORT, onde este terá
        acesso à conteúdos especializados, relacionamento com a Comunidade de
        técnicos e à plataforma de atendimento de Jobs (chamados técnicos).
      </p>
      <p>
        1.2. Os serviços disponibilizados através da plataforma NETSUPPORT têm
        por finalidade oferecer um sistema de contratação de serviços, por meio
        da interface entre as Partes, conectando o usuário CLIENTE e o
        SUPPORTER, que será um prestador de serviços autônomo e independente.
      </p>
      <p>
        1.3. Poderá o SUPPORTER aceitar ou recusar os Jobs oferecidos pela
        NETSUPPORT, bem como colaborar ou não com os conteúdos gerados na
        plataforma, a seu exclusivo critério.
      </p>
      <p>
        1.4. Fica o SUPPORTER ciente de que, os elementos e ferramentas contidos
        na Plataforma, o que inclui, sem se limitar a, software, imagens,
        textos, gráficos, ilustrações, logotipos, patentes, marcas, áudio,
        vídeos, e todos os direitos de propriedade intelectual a estes
        relacionados, são de propriedade exclusiva da NETSUPPORT, não podendo
        ser, em hipótese alguma, redistribuídos, comercializadas e/ou
        reproduzido seu conteúdo ou parte dele, pelo SUPPORTER ou qualquer
        terceiro sem o consentimento prévio e expresso da NETSUPPORT.
      </p>
      <p>
        1.5. Por meio deste instrumento ficam também estabelecidos os termos e
        condições nas quais o SUPPORTER poderá colaborar para a geração de valor
        e conhecimento por meio de Conteúdo produzido por si ou adaptado para a
        NetSupport.
      </p>
      <br />
      <h5 style="font-weight: bold; text-align: left">
        2. DAS OBRIGAÇÕES DA NETSUPPORT
      </h5>
      <p>2.1. A NETSUPPORT se compromete a:</p>
      <p>
        a) Hospedar o perfil do SUPPORTER no banco de dados da plataforma
        NETSUPPORT;
      </p>
      <p>
        b) Permitir acesso à testes de perfil por ocasião do cadastro na
        Comunidade, que visam melhor identificar o nível de conhecimento e
        especialização técnica do SUPPORTER, e qualificá-lo para receber
        oportunidades de Jobs compatíveis ao seu skill (perfil profissional);
      </p>
      <p>
        c) Repassar Jobs presenciais na região atendida pela NETSUPPORT e Jobs
        remotos em todo o Brasil;
      </p>
      <p>
        d) Garantir ao SUPPORTER que esteja plenamente regularizado perante a
        empresa, acesso ao Portal do SUPPORTER, plataforma oficial da NETSUPPORT
        para visualização e fechamento dos Jobs;
      </p>
      <p>
        e) Permitir ao SUPPORTER acesso à ferramenta de comunicação oficial da
        NETSUPPORT (NS Community), no intuito de esclarecer dúvidas técnicas
        sobre o funcionamento da plataforma, e/ou questões relativas a serviços
        aceitos ou já realizados, além de possibilitar a interação tanto com a
        NETSUPPORT quanto com a Comunidade de SUPPORTERs;
      </p>
      <p>
        f) Garantir ao SUPPORTER acesso à plataforma de gestão do conhecimento
        oficial da NETSUPPORT, “NS Academy” (Repositório com informações para
        auxiliar na solução de Jobs);
      </p>
      <p>
        g) Disponibilizar ao SUPPORTER acesso à treinamentos online para
        eventual atualização técnica do SUPPORTER, caso seja de seu interesse;
      </p>
      <p>
        h) Promover a publicidade do website http://netsupport.com.br em meios
        diversos;
      </p>

      <p>
        2.2. A NETSUPPORT utilizará a URL https://nssupport.netsupport.com.br e
        o aplicativo, para abertura, distribuição e fechamento dos Jobs .
      </p>
      <p>
        2.3. A NETSUPPORT se reserva no direito de alterar, acrescentar ou
        cancelar qualquer serviço ou facilidade disponíveis sem aviso prévio,
        incluindo alterações de preços dos Serviços.
      </p>
      <p>
        2.4. A partir do momento em que a NETSUPPORT enviar um Job ao SUPPORTER,
        por meio de seus algoritmos e regras de envio da plataforma
        (estabelecidas e esclarecidas conforme disposto no documento Regras do
        Jogo, disponível dentro do Portal do SUPPORTER), e, parte integrante e
        indissociável do presente instrumento, e, este último, por sua vez,
        deixar de manifestar, no prazo de até 05 (cinco) minutos, seja pela
        aceitação ou pela recusa do chamado, a NETSUPPORT se resguarda ao
        direito de cancelar o chamado e encaminhá-lo a outro SUPPORTER, tudo,
        com o objetivo de melhor atendimento e satisfação do usuário cliente.
      </p>
      <p>
        2.5. Em caso de não aceite nos termos, condições e prazos previamente
        estabelecidos para tanto, ou cancelamento de um serviço aceito pelo
        SUPPORTER, a NETSUPPORT repassará a oportunidade para outro SUPPORTER,
        que esteja devidamente cadastrado na plataforma, seguindo o padrão
        acordado no Documento Regras do jogo, disponível para download dentro do
        Portal do SUPPORTER.
      </p>

      <br />
      <h5 style="font-weight: bold; text-align: left">
        3. DOS DIREITOS E DEVERES DO SUPPORTER
      </h5>
      <p>
        3.1. Ao se cadastrar no site www.netsupport.com.br, o SUPPORTER declara
        estar ciente de todas as condições exigidas para seu válido
        cadastramento e acesso à Comunidade de técnicos, não podendo arguir
        desconhecimento ou manifestar discordância futura em relação aos seus
        termos.
      </p>
      <p>
        3.2. O SUPPORTER se responsabiliza pelas informações pessoais e
        profissionais prestadas no momento do seu cadastramento junto à
        Comunidade de SUPPORTERs, devendo fornecer informações precisas e
        mantê-las sempre atualizadas;
      </p>
      <p>
        3.3 O SUPPORTER se responsabiliza pelas informações disponibilizadas no
        Portal, assegurando que sempre deverá utilizar nome e dados verdadeiros
        em seu perfil;
      </p>
      <p>3.3. Cabe ao SUPPORTER cumprir o seguinte:</p>
      <p>
        a) Compromete-se a zelar pela qualidade dos serviços prestados ao
        usuário cliente, sempre norteado por valores como ética, honestidade e
        profissionalismo, e de acordo as recomendações solicitadas pelo usuário
        cliente.
      </p>
      <p>
        b) Zelar para que não haja reclamação contra si, ou qualquer reclamação
        desfavorável à imagem da NETSUPPORT, em contatos feitos por usuários
        CLIENTES nos canais de denúncia/reclamação online, incluindo, mas não se
        limitando aos sites (i) Reclame Aqui/Reclamao (ii) Facebook (iii)
        Twitter, bem como (iv) PROCON (v) outros meios de comunicação, tais como
        internet, televisão, rádio, jornais e revistas. Caso isto aconteça,
        deverá colaborar na resolução do problema, de modo que a reclamação seja
        removida pelo cliente final. Deverá ainda se comprometer a informar à
        NETSUPPORT sempre que tomar conhecimento de alguma reclamação contra a
        empresa, contribuindo para o bom nome da Comunidade no mercado.
      </p>
      <p>
        c) Deverá baixar o aplicativo da Netsupport e realizar uma triagem antes
        do atendimento do Job, para garantir que tenha todas as ferramentas e
        capacitação técnica necessárias para executar o serviço.
      </p>
      <p>
        d) Se compromete a ter expertise e deter todas ferramentas e
        conhecimento técnico para executar os serviços que aceitar, uma vez que
        o SUPPORTER possui total liberdade de escolha no momento em que lhe for
        enviado um Job, podendo aceitar ou não, prestar o serviço solicitado.
      </p>
      <p>
        e) Deverá deter todos os meios que possibilitem seu acesso ao cliente,
        incluindo, mas não se limitando a veículo (próprio, de terceiros ou
        transporte público), todas as ferramentas e equipamentos para a perfeita
        execução dos serviços, sendo de sua única e exclusiva responsabilidade a
        manutenção desses itens.
      </p>
      <p>
        f) Em caso de reclamação por parte do usuário CLIENTE, o SUPPORTER terá
        até 3 (três) dias para apresentar seu parecer, oferecendo ao CLIENTE uma
        solução para encerrar a reclamação. A NETSUPPORT intermediará esta
        negociação, conforme políticas internas de atendimento, disponíveis para
        consulta pelo site. Após o decurso do prazo definido, sem resolução da
        queixa do CLIENTE, a avaliação se tornará definitiva, e reduzirá a
        chance de o SUPPORTER ser escolhido para futuros Jobs, visto que este
        terá sua avaliação prejudicada em virtude de reclamações de CLIENTE.
      </p>
      <p>
        g) Responsabilizar-se exclusivamente pela legalidade de todos os
        softwares ou aplicativos que instalar nos equipamentos do CLIENTE,
        assumindo quaisquer repercussões civis ou criminais em caso de violação
        a direitos de licença de uso entre outras infrações legais, multas,
        ressarcimentos e/ou indenizações cabíveis;
      </p>
      <p>
        h) Em até 10 (dez) minutos após o aceite na realização de um serviço, o
        SUPPORTER poderá cancelá-lo. Caso o faça após esse período, poderá arcar
        com uma avaliação negativa no seu perfil dentro da plataforma;
      </p>
      <p>
        i) É plenamente vedado o repasse ou a terceirização da solicitação de
        serviço por um SUPPORTER que tiver manifestado aceite;
      </p>
      <p>
        j) Uma vez confirmada a prestação de serviço pelo SUPPORTER, ele
        concorda que seu Nome Completo, CPF e RG serão informados ao CLIENTE,
        para seu controle e segurança;
      </p>
      <p>
        k) Cumprir todas as leis aplicáveis, incluindo, dentre outras, Lei Geral
        de Proteção aos Dados, leis de privacidade, leis de propriedade
        intelectual, leis AntiSpam, leis tributárias e exigências regulatórias e
        todas as demais normas e procedimentos aplicáveis aos serviços por ele
        prestados;
      </p>
      <p>
        l) Criar uma senha de acesso segura, zelando para que o acesso não
        autorizado ao seu perfil não seja facilitado;
      </p>
      <p>
        m) O login e senha individual de acesso são de uso pessoal e
        intransferível, respondendo o SUPPORTER pelo uso indevido e pelo
        fornecimento dele, bem como login e senha de acesso, a terceiros.
      </p>
      <p>
        n) O SUPPORTER deverá ter, no mínimo, 18 anos de idade, e, ser
        legalmente responsável pelos seus atos;
      </p>
      <p>
        o) Permitir que a NETSUPPORT tenha acesso à conta do SUPPORTER, e ao
        conteúdo e informações dispostas em seu cadastro;
      </p>
      <p>
        p) Oferecer, nos termos e condições acordadas por meio deste
        instrumento, sempre que requerido pela NetSupport e desde que tenha
        interesse e disponibilidade para tanto, a produção, criação, gravação e
        cessão de Conteúdo, bem como de todos os direitos de propriedade
        intelectual relacionados ao material por ele produzido, a título
        universal, em caráter total, definitivo, irrevogável e irretratável,
        para que a NeSupport utilize em qualquer meio ou plataforma por ela
        designada, por período indeterminado, de forma livre e indiscriminada,
        podendo ainda compilar, editar, modificar, reduzir ou combinar com
        outros Conteúdos, sem que caiba qualquer direito ou responsabilidade
        adicional.
      </p>
      <p>
        3.4. Ao aceitar as condições expressas nesse termo, o SUPPORTER concorda
        que
        <b>NÃO poderá:</b>
      </p>
      <p>
        a) Agir desonestamente ou de maneira não profissional, inclusive
        publicando conteúdo inapropriado, impreciso ou questionável;
      </p>
      <p>
        b) Utilizar em seu perfil hospedado no portal da NETSUPPORT imagem que
        não seja condizente com a foto do SUPPORTER;
      </p>
      <p>c) Criar identidade falsa na Comunidade SUPPORTERs;</p>
      <p>
        d) Informar falsamente o cargo atual ou cargos e qualificações
        anteriores;
      </p>
      <p>
        e) Publicar conteúdo que contenha vírus de software, worms ou qualquer
        outro código prejudicial;
      </p>
      <p>
        f) Copiar ou utilizar informações, conteúdo ou dados de outras pessoas
        disponíveis nos Serviços (exceto com autorização expressa), que não
        sejam para a execução de um trabalho especificamente designado;
      </p>
      <p>
        g) Fazer engenharia reversa, descompilar, desmontar, decifrar ou, de
        outro modo, tentar copiar o código fonte dos Serviços ou de qualquer
        tecnologia relacionada, ou de qualquer parte deles;
      </p>
      <p>
        h) Declarar-se como habilitado pela NETSUPPORT sem o seu consentimento
        expresso (como, por exemplo, apresentar-se como um treinador credenciado
        da NETSUPPORT);
      </p>
      <p>
        i) Retirar quaisquer avisos de direito autoral, marca comercial ou outro
        direito de propriedade contidos no Serviço NETSUPPORT;
      </p>
      <p>
        j) Compartilhar ou divulgar informações de terceiros sem o consentimento
        expresso destes;
      </p>
      <p>
        k) Utilizar software, dispositivos, scripts robôs ou outros meios ou
        processos, manuais ou automatizados, para acessar, capturar, sondar ou
        espionar os Serviços oferecidos pela NETSUPPORT, ou quaisquer dados ou
        informações a eles relacionados ou aos seus usuários clientes;
      </p>
      <p>
        l) Utilizar bots ou outros métodos automatizados para acessar os
        Serviços, adicionar ou baixar contatos, enviar ou redirecionar
        mensagens;
      </p>
      <p>
        m) Envolver-se em atividades de “enquadramento,” “espelhamento,” ou de
        outro modo simular a aparência ou a função dos Serviços;
      </p>
      <p>
        n) Acessar os Serviços sem interfaces expressamente fornecidas pela
        NETSUPPORT;
      </p>
      <p>
        o) Utilizar a plataforma da NETSUPPORT para oferecer serviços próprios
        ou de terceiros, estando estes relacionados ou não ao contexto de
        tecnologia da informação.
      </p>

      <br />
      <h5 style="font-weight: bold; text-align: left">
        4. DO PREÇO E PAGAMENTO
      </h5>
      <p>
        4.1. O SUPPORTER receberá tão somente pelos serviços efetivamente
        prestados aos usuários CLIENTES. Além dos valores relativos aos Jobs, o
        SUPPORTER poderá receber remuneração adicional pelos Conteúdos por ele
        produzidos e disponibilizados à NetSupport, desde que tenha sido
        estabelecida remuneração específica, no momento da abertura/pedido de
        Conteúdo. Os valores variam por tipo de Job prestado e Conteúdo, quando
        cabível, conforme informações disponibilizadas no Portal do SUPPORTER
        (Ferramenta para visualização dos Jobs) e no documento Regras do Jogo,
        que são parte integrante e indissociáveis do presente instrumento.
      </p>
      <p>
        4.2. Os pagamentos serão realizados pela NETSUPPORT ao SUPPORTER, de
        acordo com ciclos mensais de pagamentos, detalhados no documento Regras
        do jogo disponível dentro do Portal do Supporter, que é parte integrante
        e indissociável do presente instrumento.
      </p>
      <p>
        4.3. Serão transferidos SOMENTE os valores dos Jobs cujos atendimentos
        tiverem aceite do usuário cliente e com todas as informações relativas
        ao mesmo preenchidas de forma correta e legível no relatório de
        atendimento técnico (RAT), conforme documento Regras do Jogo disponível
        no Portal do Supporter. Jobs sem aceite do CLIENTE, com informações
        imprecisas ou inelegíveis somente terão seus valores transferidos no
        próximo ciclo de pagamento no mês subsequente ao mês de resolução de
        todas as pendências.
      </p>
      <p>
        4.4. O pagamento será feito apenas mediante apresentação da Nota Fiscal
        do serviço prestado. A nota deverá ser anexada no portal em até no
        máximo 2 dias uteis antes da data de pagamento, de acordo com o regime
        de ciclos detalhado no documento Regras do Jogo. A não entrega da nota
        fiscal no prazo poderá implicar em atraso no pagamento dos valores.
      </p>
      <p>
        4.4.1 Não haverá, em hipótese alguma, nenhum adiantamento de valores
        pela NETSUPPORT ao SUPPORTER.
      </p>

      <br />
      <h5 style="font-weight: bold; text-align: left">
        5. DA NÃO EXCLUSIVIDADE
      </h5>
      <p>
        5.1. O SUPPORTER se declara profissional independente, devidamente
        inscrito no CNPJ – Cadastro Nacional de Pessoas Jurídicas e adere a
        Plataforma NETSUPPORT por sua única e exclusiva vontade, atestando que a
        Plataforma e suas ferramentas não são essenciais para o desenvolvimento
        de suas atividades econômicas e que não há qualquer relação hierárquica,
        de dependência, subordinação ou trabalhista entre o SUPPORTER,
        NETSUPPORT e/ou os usuários CLIENTES que solicitam a prestação de
        serviços mediante a plataforma, podendo o SUPPORTER prestar livremente e
        sem ingerência da NETSUPPORT os seus serviços, inclusive podendo
        livremente prestar serviços fora da Plataforma, seja como autônomo,
        empregado, , ou celebrar contratos da mesma natureza com terceiros, sem
        que isto represente qualquer implicação ou ônus, não havendo
        exclusividade entre as Partes.
      </p>

      <br />
      <h5 style="font-weight: bold; text-align: left">
        6. DA LIMITAÇÃO DE RESPONSABILIDADE DA NETSUPPORT
      </h5>
      <p>
        6.1. A responsabilidade da NETSUPPORT se restringe a atuar como
        intermediador da contratação dos Serviços dos usuários Clientes ao
        SUPPORTER.
      </p>
      <p>
        6.2. Será de inteira responsabilidade do SUPPORTER os serviços prestados
        ao CLIENTE, respondendo este diretamente pelos danos e prejuízos que
        eventualmente causar, bem como pelas informações incorretas/imprecisas
        prestadas, não respondendo a NETSUPPORT por nenhum ônus.
      </p>
      <p>
        6.3. O SUPPORTER, pessoa jurídica autônoma e independente, assume
        integralmente e irrestritamente responsabilidade pelas ações e omissões
        que, eventualmente, venha a causar danos ao CLIENTE.
      </p>
      <p>
        6.4. Em caso de ação judicial proposta por algum CLIENTE em face da
        NETSUPPORT, em decorrência de qualquer ação ou omissão praticada após o
        “aceite” do respectivo serviço pelo SUPPORTER, este declara ser
        exclusivamente responsável por eventuais danos causados ao cliente
        usuário, e, obriga-se através da presente cláusula, a indenizar a
        NETSUPPORT por todos os prejuízos decorrentes de condenação judicial,
        custas processuais e honorários advocatícios, cabendo à NETSUPPORT o
        direito de regresso contra o SUPPORTER em caso de eventual condenação
        judicial.
      </p>

      <br />
      <h5 style="font-weight: bold; text-align: left">7. DA VIGÊNCIA</h5>
      <p>
        7.1. O presente contrato terá vigência por prazo indeterminado,
        possuindo termo inicial com o aceite eletrônico deste Termo.
      </p>
      <p>
        7.2. O SUPPORTER só estará efetivamente inserido na lista de SUPPORTERs
        credenciados da NETSUPPORT, e poderá usufruir dos serviços
        disponibilizados, após aprovação por meio de confirmação do aceite do
        perfil do SUPPORTER, através de e-mail a ser enviado pela NETSUPPORT e
        finalização de todas as pendências dispostas dentro do portal do
        SUPPORTER, explicadas no documento Regras do Jogo, que é parte
        integrante e indissociável do presente instrumento.
      </p>

      <br />
      <h5 style="font-weight: bold; text-align: left">8. DO INADIMPLEMENTO</h5>
      <p>
        8.1. O presente contrato poderá ser rescindido de pleno direito, sem
        necessidade de notificação ou interpelação prévia e por justa causa, nas
        seguintes hipóteses:
      </p>
      <p>
        a) ocorrer a utilização indevida, por qualquer das partes, do nome e/ou
        marca da outra parte;
      </p>
      <p>b) a desídia no cumprimento do presente instrumento;</p>
      <p>
        c) o inadimplemento das cláusulas e disposições e das obrigações nele
        pactuadas;
      </p>
      <p>d) a utilização do presente termo para fins ilícitos;</p>
      <p>e) em razão de ordem judicial expressa.</p>
      <p>
        8.2. A rescisão ou resolução do presente contrato por quaisquer das
        formas previstas acima, em nada altera os compromissos assumidos entre
        as partes até a efetiva extinção do presente contrato.
      </p>
      <p>
        8.3. O SUPPORTER pode, a qualquer momento, cancelar este contrato,
        bastando para isto desabilitar sua conta no Portal do Supporter.
      </p>
      <p>
        8.4. A NETSUPPORT se resguarda ao direito de rescindir este contrato em
        caso de avaliações negativas recorrentes do SUPPORTER provenientes dos
        usuários clientes.
      </p>
      <br />
      <h5 style="font-weight: bold; text-align: left">
        9. DAS DISPOSIÇÕES FINAIS
      </h5>
      <p>
        9.1. A NETSUPPORT poderá efetivar, sem prévia consulta, revisões e
        adequações do presente instrumento, a fim de que adequá-los aos anseios
        e necessidades do mercado, e a novas determinações estabelecidas pela
        legislação aplicável, podendo inclusive alterar o valor dos Jobs.
      </p>
      <p>
        9.2. Os Jobs (chamados técnicos) serão enviados exclusivamente por meio
        da plataforma da NETSUPPORT (Telegram/e-mail/sistema em qualquer horário
        do dia ou da noite, 07 (sete) dias por semana.
      </p>
      <p>
        9.3. Ainda que os Jobs sejam enviados a qualquer horário, o SUPPORTER
        não terá qualquer obrigação em relação ao cumprimento de jornada,
        determinação de horário de trabalho ou comparecimento na sede da
        NETSUPPORT, devendo empregar seu tempo de acordo com a sua conveniência
        e disponibilidade, informadas no momento do seu cadastramento.
      </p>
      <p>
        9.4. As Partes se comprometem a não realizar qualquer tipo de tratamento
        de dados pessoais de usuários ou do Cliente Final, conforme citado nos
        termos do Regulamento Geral da Proteção de Dados da União Europeia
        2016/679 (“GDPR”) e a Lei Geral de Proteção de Dados (Lei Federal n.
        13.709/2018, “LGPD”), além das normas e dos regulamentos adotados pelas
        competentes autoridades de proteção de dados. Caso seja necessário a
        realização de qualquer tipo e tratamento de dados, o a Parte requerente
        deverá solicitar autorização específica e expressa da outra Parte.
      </p>

      <br />
      <h5 style="font-weight: bold; text-align: left">
        10. DAS DISPOSIÇÕES GERAIS
      </h5>

      <p>
        10.1 Qualquer comunicação exigida ou permitida nos termos deste Termo
        deverá ser encaminhada à NETSUPPORT por meio do endereço eletrônico
        <b>nsresolve@netsupport.com.br</b>.
      </p>
      <p>
        10.2 Salvo quando expressamente previsto no presente Termo, o presente
        instrumento não confere nenhum direito sobre qualquer pessoa que não
        seja Parte do presente instrumento.
      </p>
      <p>
        10.3 Este Termo ou quaisquer direitos sob este instrumento não pode ser
        cedido ou transferido pelo SUPPORTER, no todo ou em parte,
        voluntariamente ou por força de lei, sem o prévio consentimento por
        escrito da NETSUPPORT. O presente Termo será vinculativo e reverterá em
        benefício das Partes e seus respectivos sucessores e cessionários. Não
        obstante qualquer disposição em contrário, NETSUPPORT terá o direito de
        subcontratar qualquer de suas obrigações a terceiros, independente de
        prévia autorização do SUPPORTER.
      </p>
      <p>
        10.4 Este Termo e qualquer disputa ou reivindicações decorrentes ou em
        conexão com ele ou o seu objeto ou a formação (incluindo disputas
        extracontratuais) são regidos e interpretados de acordo com as leis
        brasileiras. As partes concordam irrevogavelmente que o Foro de
        Uberlândia - MG tem competência exclusiva para dirimir qualquer disputa
        ou reclamação resultante de ou em conexão com o presente Termo ou o seu
        objeto ou a formação (incluindo os litígios extracontratuais ou
        reivindicações).
      </p>
      <p>
        10.5 A relação entre NETSUPPORT e SUPPORTER estabelecida pelo presente
        Termo é a de contratantes independentes e nada contido neste Termo
        deverá ser interpretado ou entendido de forma a dar a qualquer das
        partes o poder de dirigir ou controlar as atividades da outra Parte ou
        constituir as Partes como parceiros, joint-ventures, coproprietários ou
        de outra forma como participantes de uma empresa comum.
      </p>
      <p>
        10.6 Caso qualquer disposição do presente Acordo entre em conflito com a
        lei que o rege ou se qualquer disposição for considerada nula, inválida
        ou ineficaz ou por um tribunal de jurisdição competente, tal disposição
        deverá ser atualizada para refletir tanto quanto possível as intenções
        originais das Partes, em conformidade com a legislação aplicável; e os
        demais termos, disposições, convênios e restrições deste Termo
        permanecerão em pleno vigor e efeito.
      </p>
      <p>
        10.7 A falha de qualquer das Partes no cumprimento, a qualquer tempo, de
        qualquer das disposições do presente Acordo não será considerada como
        uma renúncia do direito das Partes de fazer cumprir doravante as
        disposições desse tipo. Nenhuma renúncia, alteração ou modificação a
        este Acordo será válida, a menos que por escrito e assinada por ambas as
        Partes.
      </p>
      <p>
        10.8 Os títulos das seções são utilizados apenas para facilitar o
        entendimento e servem como referência apenas e não fazem parte do
        presente Termo.
      </p>
      <p>
        10.9 O SUPPORTER reconhece ter lido os termos e condições estabelecidos
        neste Termo, entende todos os termos e condições, e concorda em ficar
        por eles vinculado. Nenhum funcionário, agente, representante ou filial
        da NETSUPPORT tem autoridade para vincular a NETSUPPORT a quaisquer
        representações orais ou garantias relativas ao Serviço. Qualquer
        representação não escrita ou garantia não expressamente contidas no
        presente Termo não será exequível.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Termo",
  props: { info: Boolean },
  mounted() {

    let myDiv = this.$refs.termoContent
    myDiv.onscroll = function () {

      if (myDiv.offsetHeight + myDiv.scrollTop > (myDiv.scrollHeight - 1200)) {
        document.getElementById('warn').innerHTML = ""
        document.getElementById('btn_termo').disabled = false
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;

.termo {
  border-radius: 12px;
  padding: 45px 35px;

  @media (max-width: $small) {
    padding: 45px 25px;
  }

  .title {
    font-size: 22px;
    font-weight: 600;
    padding: 30px 0px;
    color: $purple;
  }

  .content {
    color: $gray-1;
    text-align: justify;
    font-size: 12px;
    line-height: 27px;
    max-height: 500px;
    overflow: auto;
  }
}
</style>